import { Navigate } from "@/components/_molecules/navigation-controls/navigate";
import { lazyRoute } from "@/routes/lazy-route";

const ScenarioLayout = lazyRoute(() => import("../scenario/routes/scenario.layout"), "ScenarioLayout");
const ScenarioPage = lazyRoute(() => import("../scenario/routes/scenario.page"), "ScenarioPage");
const ScenarioModelLayout = lazyRoute(() => import("../scenario-model/routes/$scenarioModelId/scenario-model.layout"), "ScenarioModelLayout");
const ScenarioModelPage = lazyRoute(() => import("../scenario-model/routes/$scenarioModelId/scenario-model.page"), "ScenarioModelPage");
const ScenarioModelDetailTabPage = lazyRoute(() => import("../scenario-model/routes/$scenarioModelId/scenario-model-detail-tab.page"), "ScenarioModelDetailTabPage");
const ScenarioModelTransitionListTabPage = lazyRoute(() => import("../scenario-model/routes/$scenarioModelId/scenario-model-transition-list-tab-page"), "ScenarioModelTransitionListTabPage");
const ScenarioListLayout = lazyRoute(() => import("../scenario-model/routes/scenario-model-list.layout"), "ScenarioListLayout");
const ScenarioModelListInnerLayout = lazyRoute(() => import("../scenario-model/routes/scenario-model-list-inner.layout"), "ScenarioModelListInnerLayout");
const ScenarioModelListPage = lazyRoute(() => import("../scenario-model/routes/scenario-model-list.page"), "ScenarioModelListPage");
const ScenarioTrashPage = lazyRoute(() => import("../../trash/routes/scenario-trash.page"), "ScenarioTrashPage");
const ScenarioComparisonPage = lazyRoute(() => import("../scenario-comparison/routes/scenario-comparison.page"), "ScenarioComparisonPage");
const TransitionLayout = lazyRoute(() => import("../transition/routes/transition.layout"), "TransitionLayout");
const TransitionPage = lazyRoute(() => import("../transition/routes/transition.page"), "TransitionPage");
const TransitionConfigurationPage = lazyRoute(() => import("../transition/routes/transition-configuration.page"), "TransitionConfigurationPage");
const TransitionConfigurationLayout = lazyRoute(() => import("../transition/routes/transition-configuration-layout"), "TransitionConfigurationLayout");

export const scenarioRoutes = [
  {
    path: "scenarios",
    element: <ScenarioListLayout />,
    children: [
      {
        element: <ScenarioModelListInnerLayout />,
        children: [
          { path: "", element: <ScenarioModelListPage /> },
          { path: "trash", element: <ScenarioTrashPage /> },
        ],
      },
      { path: "compare", element: <ScenarioComparisonPage /> },
      {
        path: ":scenarioModelId",
        element: <ScenarioModelLayout />,
        children: [
          {
            path: "",
            element: <ScenarioModelPage />,
            children: [
              { path: "", element: <Navigate to="details" replace /> },
              { path: "details", element: <ScenarioModelDetailTabPage /> },
              { path: "transitions", element: <ScenarioModelTransitionListTabPage /> },
              {
                path: "scenario",
                children: [
                  {
                    path: ":scenarioId",
                    element: <ScenarioLayout />,
                    children: [
                      {
                        path: "",
                        element: <ScenarioPage />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "transitions/:transitionId",
            element: <TransitionLayout />,
            children: [
              {
                path: "",
                element: <TransitionPage />,
              },
              {
                path: "configurations/:transitionConfigurationId",
                element: <TransitionConfigurationLayout />,
                children: [
                  {
                    path: "",
                    element: <TransitionConfigurationPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
